import styled from '@emotion/styled'

export const Footer = styled.div`
  display: flex;
  gap: 10px;
`
